export default function RestraintFlagsHeadingSlot() {
  // Empty heading wrapper — Curtains/Gates pills below have their own labels.
  // Reserved so a future Phase 2 override can rename "Restraint flags".
  return <div className="pt-1" data-testid="restraint-flags-heading" />;
}
